import { Inject, Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable, delay, map, of, switchMap, tap } from "rxjs";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { DOCUMENT } from "@angular/common";
import { Browser } from "@capacitor/browser";

@Injectable({
  providedIn: "root",
})
export class SendWhatsappMessageAllPlatforms {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  execute(message: string, phoneNumber: string): Observable<string> {
    return of("message").pipe(
      //For some reason, without delay(0) in capacitor is not opening
      //the window.open if there is a asyncronous operatorion like an httpRequest.
      // It doesn't make sense but this way is working.
      delay(0),
      tap(() => {
        let url =
          "https://api.whatsapp.com/send?text=" +
          encodeURIComponent(message) +
          "&phone=" +
          phoneNumber;
        window.open(url);
      })
    );
  }
}
